/* eslint-disable react/display-name */
import * as React from 'react';
import { PasswordRequiredModalContent } from '@zen/common-app-parts';
import { DexExecutionStore } from '@zen-dex/utils';
import usePreventAction from '../../../../../../utils/usePreventAction';
import ConfirmMakeTake from '../ConfirmMakeTake';

export default function MakeOrderModalProcess({
  onSuccess,
  onError,
  onCancel,
  base,
  quote,
  original,
  rounded,
  isBuy,
}) {
  const [status, setStatus] = React.useState('confirm-order');
  const { preventAction } = usePreventAction();
  const executionStore = DexExecutionStore.useStore();

  const handleConfirmOrderCancel = () => {
    onCancel();
  };
  const handleConfirmOrderContinue = () => {
    setStatus('password');
  };

  const handlePasswordBack = () => {
    setStatus('confirm-order');
  };
  const handlePasswordContinue = async (password) => {
    if (preventAction()) return;

    try {
      await executionStore.actions.createOrder({
        isBuy,
        base,
        quote,
        quantity: rounded.quantity,
        total: rounded.total,
        password,
      });
      onSuccess();
    } catch (error) {
      onError(error);
    }
  };

  if (status === 'confirm-order') {
    return (
      <ConfirmMakeTake
        title={`Confirm making a ${isBuy ? 'buy' : 'sell'} order`}
        asset={base}
        command="make"
        isBuy={isBuy}
        original={original}
        rounded={rounded}
        onCancel={handleConfirmOrderCancel}
        onConfirm={handleConfirmOrderContinue}
        quote={quote}
      />
    );
  }

  if (status === 'password') {
    return (
      <PasswordRequiredModalContent
        cancelText="Back"
        submitText="Make Order"
        onCancel={handlePasswordBack}
        onSuccess={handlePasswordContinue}
      />
    );
  }

  return null;
}
